module.exports = __webpack_public_path__ + "static/media/Preview_iOS_Notification.c0a02ce0.png";